import React from 'react'
import { useNavigate } from 'react-router-dom'
import ProfilePicture from '../../../../Components/ProfilePicture'
import style from './style.module.scss';

function UserResult({user, }) {
    const navigate = useNavigate();
    const onClickNavigate = () => {
        navigate(`/${user.username}`);
    }
  return (
    <div className={style.container} onClick={onClickNavigate}>
        <div className={style.userResult}>
            <ProfilePicture url={user.profilePicture} onClick={onClickNavigate} isExplore={true}/>
            <div className={style.infoHolder}>
                <h6 className={style.name} onClick={onClickNavigate}>{user.name}</h6>
                <p className={style.username} onClick={onClickNavigate}>{`@${user.username}`}</p>   
            </div>
        </div>
    </div>
  )
}

export default UserResult